module.exports = __webpack_public_path__ + "img/center.5748c34a.png";